// AUTO-GENERATED by scripts/compute-indexable-pages.mjs — DO NOT EDIT.
// Programmatic /browse combo pages backed by at least 3 active
// listings. Used by the sitemap generator (to exclude thin pages) and the
// Netlify edge meta injector (to mark thin pages noindex). Regenerated on build.
export const MIN_LISTINGS_FOR_INDEX = 3;

export const INDEXABLE_BROWSE_PATHS: readonly string[] = [
  "/browse/alabama",
  "/browse/alabama/birmingham",
  "/browse/alabama/birmingham/best",
  "/browse/alabama/birmingham/botox",
  "/browse/alabama/birmingham/dermal-fillers",
  "/browse/alabama/birmingham/hydrafacial",
  "/browse/alabama/birmingham/laser-hair-removal",
  "/browse/alabama/birmingham/microneedling",
  "/browse/alabama/birmingham/rf-microneedling",
  "/browse/alabama/treatments/botox",
  "/browse/alabama/treatments/chemical-peels",
  "/browse/alabama/treatments/dermal-fillers",
  "/browse/alabama/treatments/hydrafacial",
  "/browse/alabama/treatments/iv-therapy",
  "/browse/alabama/treatments/laser-hair-removal",
  "/browse/alabama/treatments/microneedling",
  "/browse/alabama/treatments/rf-microneedling",
  "/browse/alabama/treatments/semaglutide-glp-1",
  "/browse/alaska",
  "/browse/alaska/treatments/botox",
  "/browse/alaska/treatments/dermal-fillers",
  "/browse/alaska/treatments/laser-hair-removal",
  "/browse/alaska/treatments/microneedling",
  "/browse/alaska/treatments/rf-microneedling",
  "/browse/arizona",
  "/browse/arizona/phoenix",
  "/browse/arizona/phoenix/best",
  "/browse/arizona/phoenix/botox",
  "/browse/arizona/phoenix/chemical-peels",
  "/browse/arizona/phoenix/dermal-fillers",
  "/browse/arizona/phoenix/dysport",
  "/browse/arizona/phoenix/kybella",
  "/browse/arizona/phoenix/laser-hair-removal",
  "/browse/arizona/phoenix/lip-fillers",
  "/browse/arizona/phoenix/medical-weight-loss",
  "/browse/arizona/phoenix/microneedling",
  "/browse/arizona/phoenix/sculptra",
  "/browse/arizona/scottsdale",
  "/browse/arizona/scottsdale/best",
  "/browse/arizona/scottsdale/botox",
  "/browse/arizona/scottsdale/chemical-peels",
  "/browse/arizona/scottsdale/dermal-fillers",
  "/browse/arizona/scottsdale/dysport",
  "/browse/arizona/scottsdale/laser-hair-removal",
  "/browse/arizona/scottsdale/lip-fillers",
  "/browse/arizona/scottsdale/medical-weight-loss",
  "/browse/arizona/scottsdale/microneedling",
  "/browse/arizona/scottsdale/sculptra",
  "/browse/arizona/treatments/botox",
  "/browse/arizona/treatments/chemical-peels",
  "/browse/arizona/treatments/dermal-fillers",
  "/browse/arizona/treatments/hydrafacial",
  "/browse/arizona/treatments/laser-hair-removal",
  "/browse/arizona/treatments/lip-fillers",
  "/browse/arizona/treatments/microneedling",
  "/browse/arizona/treatments/rf-microneedling",
  "/browse/arizona/treatments/semaglutide-glp-1",
  "/browse/arkansas",
  "/browse/arkansas/treatments/botox",
  "/browse/arkansas/treatments/chemical-peels",
  "/browse/arkansas/treatments/dermal-fillers",
  "/browse/arkansas/treatments/hydrafacial",
  "/browse/arkansas/treatments/iv-therapy",
  "/browse/arkansas/treatments/laser-hair-removal",
  "/browse/arkansas/treatments/microneedling",
  "/browse/california",
  "/browse/california/los-angeles",
  "/browse/california/los-angeles/best",
  "/browse/california/los-angeles/botox",
  "/browse/california/los-angeles/chemical-peels",
  "/browse/california/los-angeles/coolsculpting",
  "/browse/california/los-angeles/dermal-fillers",
  "/browse/california/los-angeles/dysport",
  "/browse/california/los-angeles/emsculpt",
  "/browse/california/los-angeles/hydrafacial",
  "/browse/california/los-angeles/ipl-photofacial",
  "/browse/california/los-angeles/iv-therapy",
  "/browse/california/los-angeles/kybella",
  "/browse/california/los-angeles/laser-hair-removal",
  "/browse/california/los-angeles/laser-skin-resurfacing",
  "/browse/california/los-angeles/lip-fillers",
  "/browse/california/los-angeles/medical-weight-loss",
  "/browse/california/los-angeles/microneedling",
  "/browse/california/los-angeles/morpheus8",
  "/browse/california/los-angeles/prp-injections",
  "/browse/california/los-angeles/rf-microneedling",
  "/browse/california/los-angeles/sculptra",
  "/browse/california/los-angeles/semaglutide-glp-1",
  "/browse/california/sacramento",
  "/browse/california/sacramento/best",
  "/browse/california/san-diego",
  "/browse/california/san-diego/best",
  "/browse/california/san-diego/botox",
  "/browse/california/san-diego/chemical-peels",
  "/browse/california/san-diego/dermal-fillers",
  "/browse/california/san-diego/dysport",
  "/browse/california/san-diego/ipl-photofacial",
  "/browse/california/san-diego/laser-hair-removal",
  "/browse/california/san-diego/medical-weight-loss",
  "/browse/california/san-diego/microneedling",
  "/browse/california/san-diego/morpheus8",
  "/browse/california/san-diego/rf-microneedling",
  "/browse/california/san-diego/sculptra",
  "/browse/california/san-francisco",
  "/browse/california/san-francisco/best",
  "/browse/california/san-francisco/botox",
  "/browse/california/san-francisco/coolsculpting",
  "/browse/california/san-francisco/dermal-fillers",
  "/browse/california/san-francisco/dysport",
  "/browse/california/san-francisco/hydrafacial",
  "/browse/california/san-francisco/ipl-photofacial",
  "/browse/california/san-francisco/kybella",
  "/browse/california/san-francisco/laser-hair-removal",
  "/browse/california/san-francisco/laser-skin-resurfacing",
  "/browse/california/san-francisco/medical-weight-loss",
  "/browse/california/san-francisco/microneedling",
  "/browse/california/san-francisco/morpheus8",
  "/browse/california/san-francisco/sculptra",
  "/browse/california/treatments/botox",
  "/browse/california/treatments/chemical-peels",
  "/browse/california/treatments/coolsculpting",
  "/browse/california/treatments/dermal-fillers",
  "/browse/california/treatments/hydrafacial",
  "/browse/california/treatments/iv-therapy",
  "/browse/california/treatments/laser-hair-removal",
  "/browse/california/treatments/lip-fillers",
  "/browse/california/treatments/microneedling",
  "/browse/california/treatments/morpheus8",
  "/browse/california/treatments/rf-microneedling",
  "/browse/california/treatments/semaglutide-glp-1",
  "/browse/colorado",
  "/browse/colorado/denver",
  "/browse/colorado/denver/best",
  "/browse/colorado/denver/botox",
  "/browse/colorado/denver/chemical-peels",
  "/browse/colorado/denver/dermal-fillers",
  "/browse/colorado/denver/dysport",
  "/browse/colorado/denver/ipl-photofacial",
  "/browse/colorado/denver/kybella",
  "/browse/colorado/denver/laser-hair-removal",
  "/browse/colorado/denver/lip-fillers",
  "/browse/colorado/denver/microneedling",
  "/browse/colorado/treatments/botox",
  "/browse/colorado/treatments/chemical-peels",
  "/browse/colorado/treatments/coolsculpting",
  "/browse/colorado/treatments/dermal-fillers",
  "/browse/colorado/treatments/hydrafacial",
  "/browse/colorado/treatments/laser-hair-removal",
  "/browse/colorado/treatments/lip-fillers",
  "/browse/colorado/treatments/microneedling",
  "/browse/colorado/treatments/morpheus8",
  "/browse/colorado/treatments/rf-microneedling",
  "/browse/colorado/treatments/semaglutide-glp-1",
  "/browse/florida",
  "/browse/florida/fort-lauderdale",
  "/browse/florida/fort-lauderdale/best",
  "/browse/florida/fort-lauderdale/botox",
  "/browse/florida/fort-lauderdale/dermal-fillers",
  "/browse/florida/fort-lauderdale/medical-weight-loss",
  "/browse/florida/miami",
  "/browse/florida/miami/best",
  "/browse/florida/miami/botox",
  "/browse/florida/miami/dermal-fillers",
  "/browse/florida/miami/dysport",
  "/browse/florida/miami/hydrafacial",
  "/browse/florida/miami/iv-therapy",
  "/browse/florida/miami/laser-hair-removal",
  "/browse/florida/miami/lip-fillers",
  "/browse/florida/miami/medical-weight-loss",
  "/browse/florida/miami/microneedling",
  "/browse/florida/miami/morpheus8",
  "/browse/florida/miami/sculptra",
  "/browse/florida/orlando",
  "/browse/florida/orlando/best",
  "/browse/florida/orlando/botox",
  "/browse/florida/orlando/chemical-peels",
  "/browse/florida/orlando/dermal-fillers",
  "/browse/florida/orlando/dysport",
  "/browse/florida/orlando/iv-therapy",
  "/browse/florida/orlando/kybella",
  "/browse/florida/orlando/lip-fillers",
  "/browse/florida/orlando/medical-weight-loss",
  "/browse/florida/orlando/microneedling",
  "/browse/florida/orlando/rf-microneedling",
  "/browse/florida/orlando/sculptra",
  "/browse/florida/tampa",
  "/browse/florida/tampa/best",
  "/browse/florida/tampa/botox",
  "/browse/florida/tampa/dermal-fillers",
  "/browse/florida/tampa/microneedling",
  "/browse/florida/tampa/morpheus8",
  "/browse/florida/treatments/botox",
  "/browse/florida/treatments/chemical-peels",
  "/browse/florida/treatments/coolsculpting",
  "/browse/florida/treatments/dermal-fillers",
  "/browse/florida/treatments/hydrafacial",
  "/browse/florida/treatments/iv-therapy",
  "/browse/florida/treatments/laser-hair-removal",
  "/browse/florida/treatments/lip-fillers",
  "/browse/florida/treatments/microneedling",
  "/browse/florida/treatments/morpheus8",
  "/browse/florida/treatments/rf-microneedling",
  "/browse/florida/treatments/semaglutide-glp-1",
  "/browse/georgia",
  "/browse/georgia/atlanta",
  "/browse/georgia/atlanta/best",
  "/browse/georgia/atlanta/botox",
  "/browse/georgia/atlanta/dermal-fillers",
  "/browse/georgia/atlanta/laser-hair-removal",
  "/browse/georgia/atlanta/microneedling",
  "/browse/georgia/treatments/botox",
  "/browse/georgia/treatments/chemical-peels",
  "/browse/georgia/treatments/dermal-fillers",
  "/browse/georgia/treatments/hydrafacial",
  "/browse/georgia/treatments/iv-therapy",
  "/browse/georgia/treatments/laser-hair-removal",
  "/browse/georgia/treatments/lip-fillers",
  "/browse/georgia/treatments/microneedling",
  "/browse/georgia/treatments/morpheus8",
  "/browse/georgia/treatments/rf-microneedling",
  "/browse/hawaii",
  "/browse/hawaii/treatments/botox",
  "/browse/hawaii/treatments/dermal-fillers",
  "/browse/hawaii/treatments/iv-therapy",
  "/browse/hawaii/treatments/laser-hair-removal",
  "/browse/hawaii/treatments/microneedling",
  "/browse/idaho",
  "/browse/idaho/boise",
  "/browse/idaho/boise/best",
  "/browse/idaho/boise/botox",
  "/browse/idaho/boise/chemical-peels",
  "/browse/idaho/boise/coolsculpting",
  "/browse/idaho/boise/dermal-fillers",
  "/browse/idaho/boise/dysport",
  "/browse/idaho/boise/hydrafacial",
  "/browse/idaho/boise/ipl-photofacial",
  "/browse/idaho/boise/laser-hair-removal",
  "/browse/idaho/boise/lip-fillers",
  "/browse/idaho/boise/medical-weight-loss",
  "/browse/idaho/boise/microneedling",
  "/browse/idaho/boise/rf-microneedling",
  "/browse/idaho/boise/sculptra",
  "/browse/idaho/boise/semaglutide-glp-1",
  "/browse/idaho/treatments/botox",
  "/browse/idaho/treatments/chemical-peels",
  "/browse/idaho/treatments/coolsculpting",
  "/browse/idaho/treatments/dermal-fillers",
  "/browse/idaho/treatments/hydrafacial",
  "/browse/idaho/treatments/iv-therapy",
  "/browse/idaho/treatments/laser-hair-removal",
  "/browse/idaho/treatments/lip-fillers",
  "/browse/idaho/treatments/microneedling",
  "/browse/idaho/treatments/morpheus8",
  "/browse/idaho/treatments/rf-microneedling",
  "/browse/idaho/treatments/semaglutide-glp-1",
  "/browse/illinois",
  "/browse/illinois/chicago",
  "/browse/illinois/chicago/best",
  "/browse/illinois/chicago/botox",
  "/browse/illinois/chicago/chemical-peels",
  "/browse/illinois/chicago/dermal-fillers",
  "/browse/illinois/chicago/dysport",
  "/browse/illinois/chicago/laser-hair-removal",
  "/browse/illinois/chicago/lip-fillers",
  "/browse/illinois/chicago/medical-weight-loss",
  "/browse/illinois/chicago/microneedling",
  "/browse/illinois/chicago/rf-microneedling",
  "/browse/illinois/chicago/sculptra",
  "/browse/illinois/chicago/semaglutide-glp-1",
  "/browse/illinois/treatments/botox",
  "/browse/illinois/treatments/chemical-peels",
  "/browse/illinois/treatments/dermal-fillers",
  "/browse/illinois/treatments/iv-therapy",
  "/browse/illinois/treatments/laser-hair-removal",
  "/browse/illinois/treatments/lip-fillers",
  "/browse/illinois/treatments/microneedling",
  "/browse/illinois/treatments/rf-microneedling",
  "/browse/illinois/treatments/semaglutide-glp-1",
  "/browse/indiana",
  "/browse/indiana/indianapolis",
  "/browse/indiana/indianapolis/best",
  "/browse/indiana/indianapolis/botox",
  "/browse/indiana/indianapolis/chemical-peels",
  "/browse/indiana/indianapolis/coolsculpting",
  "/browse/indiana/indianapolis/dermal-fillers",
  "/browse/indiana/indianapolis/dysport",
  "/browse/indiana/indianapolis/ipl-photofacial",
  "/browse/indiana/indianapolis/laser-hair-removal",
  "/browse/indiana/indianapolis/medical-weight-loss",
  "/browse/indiana/indianapolis/microneedling",
  "/browse/indiana/indianapolis/sculptra",
  "/browse/indiana/treatments/botox",
  "/browse/indiana/treatments/chemical-peels",
  "/browse/indiana/treatments/coolsculpting",
  "/browse/indiana/treatments/dermal-fillers",
  "/browse/indiana/treatments/iv-therapy",
  "/browse/indiana/treatments/laser-hair-removal",
  "/browse/indiana/treatments/lip-fillers",
  "/browse/indiana/treatments/microneedling",
  "/browse/iowa",
  "/browse/iowa/des-moines",
  "/browse/iowa/des-moines/best",
  "/browse/iowa/des-moines/laser-hair-removal",
  "/browse/iowa/des-moines/microneedling",
  "/browse/iowa/treatments/botox",
  "/browse/iowa/treatments/chemical-peels",
  "/browse/iowa/treatments/dermal-fillers",
  "/browse/iowa/treatments/hydrafacial",
  "/browse/iowa/treatments/laser-hair-removal",
  "/browse/iowa/treatments/microneedling",
  "/browse/iowa/treatments/morpheus8",
  "/browse/iowa/treatments/rf-microneedling",
  "/browse/kansas",
  "/browse/kansas/treatments/botox",
  "/browse/kansas/treatments/chemical-peels",
  "/browse/kansas/treatments/dermal-fillers",
  "/browse/kansas/treatments/hydrafacial",
  "/browse/kansas/treatments/laser-hair-removal",
  "/browse/kansas/treatments/microneedling",
  "/browse/kansas/treatments/rf-microneedling",
  "/browse/kansas/treatments/semaglutide-glp-1",
  "/browse/kentucky",
  "/browse/kentucky/louisville",
  "/browse/kentucky/louisville/best",
  "/browse/kentucky/louisville/chemical-peels",
  "/browse/kentucky/louisville/dermal-fillers",
  "/browse/kentucky/louisville/laser-hair-removal",
  "/browse/kentucky/louisville/microneedling",
  "/browse/kentucky/treatments/botox",
  "/browse/kentucky/treatments/chemical-peels",
  "/browse/kentucky/treatments/coolsculpting",
  "/browse/kentucky/treatments/dermal-fillers",
  "/browse/kentucky/treatments/hydrafacial",
  "/browse/kentucky/treatments/iv-therapy",
  "/browse/kentucky/treatments/laser-hair-removal",
  "/browse/kentucky/treatments/microneedling",
  "/browse/kentucky/treatments/morpheus8",
  "/browse/kentucky/treatments/rf-microneedling",
  "/browse/louisiana",
  "/browse/louisiana/new-orleans",
  "/browse/louisiana/new-orleans/best",
  "/browse/louisiana/new-orleans/botox",
  "/browse/louisiana/new-orleans/chemical-peels",
  "/browse/louisiana/new-orleans/ipl-photofacial",
  "/browse/louisiana/new-orleans/medical-weight-loss",
  "/browse/louisiana/new-orleans/microneedling",
  "/browse/louisiana/new-orleans/morpheus8",
  "/browse/louisiana/treatments/botox",
  "/browse/louisiana/treatments/chemical-peels",
  "/browse/louisiana/treatments/dermal-fillers",
  "/browse/louisiana/treatments/laser-hair-removal",
  "/browse/louisiana/treatments/microneedling",
  "/browse/louisiana/treatments/morpheus8",
  "/browse/maine",
  "/browse/maine/treatments/botox",
  "/browse/maine/treatments/dermal-fillers",
  "/browse/maryland",
  "/browse/maryland/treatments/botox",
  "/browse/maryland/treatments/chemical-peels",
  "/browse/maryland/treatments/dermal-fillers",
  "/browse/maryland/treatments/hydrafacial",
  "/browse/maryland/treatments/iv-therapy",
  "/browse/maryland/treatments/laser-hair-removal",
  "/browse/maryland/treatments/lip-fillers",
  "/browse/maryland/treatments/microneedling",
  "/browse/massachusetts",
  "/browse/massachusetts/treatments/botox",
  "/browse/massachusetts/treatments/chemical-peels",
  "/browse/massachusetts/treatments/dermal-fillers",
  "/browse/massachusetts/treatments/iv-therapy",
  "/browse/massachusetts/treatments/laser-hair-removal",
  "/browse/massachusetts/treatments/microneedling",
  "/browse/massachusetts/treatments/rf-microneedling",
  "/browse/michigan",
  "/browse/michigan/treatments/botox",
  "/browse/michigan/treatments/chemical-peels",
  "/browse/michigan/treatments/dermal-fillers",
  "/browse/michigan/treatments/hydrafacial",
  "/browse/michigan/treatments/iv-therapy",
  "/browse/michigan/treatments/laser-hair-removal",
  "/browse/michigan/treatments/lip-fillers",
  "/browse/michigan/treatments/microneedling",
  "/browse/michigan/treatments/rf-microneedling",
  "/browse/minnesota",
  "/browse/minnesota/treatments/botox",
  "/browse/minnesota/treatments/chemical-peels",
  "/browse/minnesota/treatments/dermal-fillers",
  "/browse/minnesota/treatments/lip-fillers",
  "/browse/minnesota/treatments/microneedling",
  "/browse/mississippi",
  "/browse/mississippi/treatments/botox",
  "/browse/mississippi/treatments/chemical-peels",
  "/browse/mississippi/treatments/dermal-fillers",
  "/browse/mississippi/treatments/laser-hair-removal",
  "/browse/mississippi/treatments/microneedling",
  "/browse/mississippi/treatments/rf-microneedling",
  "/browse/missouri",
  "/browse/missouri/kansas-city",
  "/browse/missouri/kansas-city/best",
  "/browse/missouri/kansas-city/botox",
  "/browse/missouri/kansas-city/dermal-fillers",
  "/browse/missouri/kansas-city/dysport",
  "/browse/missouri/kansas-city/microneedling",
  "/browse/missouri/kansas-city/morpheus8",
  "/browse/missouri/st-louis",
  "/browse/missouri/st-louis/best",
  "/browse/missouri/st-louis/botox",
  "/browse/missouri/st-louis/microneedling",
  "/browse/missouri/treatments/botox",
  "/browse/missouri/treatments/chemical-peels",
  "/browse/missouri/treatments/dermal-fillers",
  "/browse/missouri/treatments/hydrafacial",
  "/browse/missouri/treatments/laser-hair-removal",
  "/browse/missouri/treatments/microneedling",
  "/browse/missouri/treatments/morpheus8",
  "/browse/montana",
  "/browse/montana/treatments/botox",
  "/browse/montana/treatments/chemical-peels",
  "/browse/montana/treatments/dermal-fillers",
  "/browse/montana/treatments/hydrafacial",
  "/browse/montana/treatments/iv-therapy",
  "/browse/montana/treatments/laser-hair-removal",
  "/browse/montana/treatments/microneedling",
  "/browse/montana/treatments/morpheus8",
  "/browse/montana/treatments/rf-microneedling",
  "/browse/nebraska",
  "/browse/nebraska/omaha",
  "/browse/nebraska/omaha/best",
  "/browse/nebraska/omaha/botox",
  "/browse/nebraska/omaha/chemical-peels",
  "/browse/nebraska/omaha/dermal-fillers",
  "/browse/nebraska/omaha/hydrafacial",
  "/browse/nebraska/omaha/ipl-photofacial",
  "/browse/nebraska/omaha/iv-therapy",
  "/browse/nebraska/omaha/kybella",
  "/browse/nebraska/omaha/medical-weight-loss",
  "/browse/nebraska/omaha/microneedling",
  "/browse/nebraska/treatments/botox",
  "/browse/nebraska/treatments/chemical-peels",
  "/browse/nebraska/treatments/dermal-fillers",
  "/browse/nebraska/treatments/hydrafacial",
  "/browse/nebraska/treatments/iv-therapy",
  "/browse/nebraska/treatments/laser-hair-removal",
  "/browse/nebraska/treatments/microneedling",
  "/browse/nebraska/treatments/rf-microneedling",
  "/browse/nebraska/treatments/semaglutide-glp-1",
  "/browse/nevada",
  "/browse/nevada/las-vegas",
  "/browse/nevada/las-vegas/best",
  "/browse/nevada/las-vegas/botox",
  "/browse/nevada/las-vegas/chemical-peels",
  "/browse/nevada/las-vegas/dermal-fillers",
  "/browse/nevada/las-vegas/dysport",
  "/browse/nevada/las-vegas/hydrafacial",
  "/browse/nevada/las-vegas/ipl-photofacial",
  "/browse/nevada/las-vegas/iv-therapy",
  "/browse/nevada/las-vegas/kybella",
  "/browse/nevada/las-vegas/laser-hair-removal",
  "/browse/nevada/las-vegas/lip-fillers",
  "/browse/nevada/las-vegas/medical-weight-loss",
  "/browse/nevada/las-vegas/microneedling",
  "/browse/nevada/las-vegas/prp-injections",
  "/browse/nevada/las-vegas/rf-microneedling",
  "/browse/nevada/las-vegas/sculptra",
  "/browse/nevada/treatments/botox",
  "/browse/nevada/treatments/chemical-peels",
  "/browse/nevada/treatments/dermal-fillers",
  "/browse/nevada/treatments/hydrafacial",
  "/browse/nevada/treatments/iv-therapy",
  "/browse/nevada/treatments/laser-hair-removal",
  "/browse/nevada/treatments/lip-fillers",
  "/browse/nevada/treatments/microneedling",
  "/browse/nevada/treatments/rf-microneedling",
  "/browse/nevada/treatments/semaglutide-glp-1",
  "/browse/new-hampshire",
  "/browse/new-hampshire/treatments/botox",
  "/browse/new-hampshire/treatments/chemical-peels",
  "/browse/new-hampshire/treatments/dermal-fillers",
  "/browse/new-hampshire/treatments/laser-hair-removal",
  "/browse/new-hampshire/treatments/lip-fillers",
  "/browse/new-hampshire/treatments/microneedling",
  "/browse/new-jersey",
  "/browse/new-jersey/treatments/botox",
  "/browse/new-jersey/treatments/chemical-peels",
  "/browse/new-jersey/treatments/dermal-fillers",
  "/browse/new-jersey/treatments/iv-therapy",
  "/browse/new-jersey/treatments/laser-hair-removal",
  "/browse/new-jersey/treatments/microneedling",
  "/browse/new-mexico",
  "/browse/new-mexico/albuquerque",
  "/browse/new-mexico/albuquerque/best",
  "/browse/new-mexico/albuquerque/botox",
  "/browse/new-mexico/albuquerque/chemical-peels",
  "/browse/new-mexico/albuquerque/dermal-fillers",
  "/browse/new-mexico/albuquerque/dysport",
  "/browse/new-mexico/albuquerque/ipl-photofacial",
  "/browse/new-mexico/albuquerque/laser-hair-removal",
  "/browse/new-mexico/albuquerque/medical-weight-loss",
  "/browse/new-mexico/albuquerque/microneedling",
  "/browse/new-mexico/treatments/botox",
  "/browse/new-mexico/treatments/chemical-peels",
  "/browse/new-mexico/treatments/dermal-fillers",
  "/browse/new-mexico/treatments/hydrafacial",
  "/browse/new-mexico/treatments/iv-therapy",
  "/browse/new-mexico/treatments/laser-hair-removal",
  "/browse/new-mexico/treatments/lip-fillers",
  "/browse/new-mexico/treatments/microneedling",
  "/browse/new-mexico/treatments/rf-microneedling",
  "/browse/new-mexico/treatments/semaglutide-glp-1",
  "/browse/new-york",
  "/browse/new-york/new-york-city",
  "/browse/new-york/new-york-city/best",
  "/browse/new-york/new-york-city/botox",
  "/browse/new-york/new-york-city/chemical-peels",
  "/browse/new-york/new-york-city/coolsculpting",
  "/browse/new-york/new-york-city/dermal-fillers",
  "/browse/new-york/new-york-city/dysport",
  "/browse/new-york/new-york-city/hydrafacial",
  "/browse/new-york/new-york-city/ipl-photofacial",
  "/browse/new-york/new-york-city/iv-therapy",
  "/browse/new-york/new-york-city/kybella",
  "/browse/new-york/new-york-city/laser-hair-removal",
  "/browse/new-york/new-york-city/lip-fillers",
  "/browse/new-york/new-york-city/medical-weight-loss",
  "/browse/new-york/new-york-city/microneedling",
  "/browse/new-york/new-york-city/morpheus8",
  "/browse/new-york/new-york-city/rf-microneedling",
  "/browse/new-york/new-york-city/sculptra",
  "/browse/new-york/new-york-city/semaglutide-glp-1",
  "/browse/new-york/treatments/botox",
  "/browse/new-york/treatments/chemical-peels",
  "/browse/new-york/treatments/coolsculpting",
  "/browse/new-york/treatments/dermal-fillers",
  "/browse/new-york/treatments/hydrafacial",
  "/browse/new-york/treatments/iv-therapy",
  "/browse/new-york/treatments/laser-hair-removal",
  "/browse/new-york/treatments/lip-fillers",
  "/browse/new-york/treatments/microneedling",
  "/browse/new-york/treatments/morpheus8",
  "/browse/new-york/treatments/rf-microneedling",
  "/browse/new-york/treatments/semaglutide-glp-1",
  "/browse/north-carolina",
  "/browse/north-carolina/charlotte",
  "/browse/north-carolina/charlotte/best",
  "/browse/north-carolina/raleigh",
  "/browse/north-carolina/raleigh/best",
  "/browse/north-carolina/raleigh/botox",
  "/browse/north-carolina/raleigh/chemical-peels",
  "/browse/north-carolina/raleigh/dermal-fillers",
  "/browse/north-carolina/raleigh/laser-hair-removal",
  "/browse/north-carolina/raleigh/medical-weight-loss",
  "/browse/north-carolina/raleigh/microneedling",
  "/browse/north-carolina/raleigh/rf-microneedling",
  "/browse/north-carolina/treatments/botox",
  "/browse/north-carolina/treatments/chemical-peels",
  "/browse/north-carolina/treatments/dermal-fillers",
  "/browse/north-carolina/treatments/hydrafacial",
  "/browse/north-carolina/treatments/iv-therapy",
  "/browse/north-carolina/treatments/laser-hair-removal",
  "/browse/north-carolina/treatments/microneedling",
  "/browse/north-carolina/treatments/rf-microneedling",
  "/browse/north-dakota",
  "/browse/north-dakota/treatments/botox",
  "/browse/north-dakota/treatments/chemical-peels",
  "/browse/north-dakota/treatments/coolsculpting",
  "/browse/north-dakota/treatments/dermal-fillers",
  "/browse/north-dakota/treatments/hydrafacial",
  "/browse/north-dakota/treatments/iv-therapy",
  "/browse/north-dakota/treatments/laser-hair-removal",
  "/browse/north-dakota/treatments/lip-fillers",
  "/browse/north-dakota/treatments/microneedling",
  "/browse/north-dakota/treatments/rf-microneedling",
  "/browse/ohio",
  "/browse/ohio/cincinnati",
  "/browse/ohio/cincinnati/best",
  "/browse/ohio/cincinnati/botox",
  "/browse/ohio/cincinnati/dermal-fillers",
  "/browse/ohio/cincinnati/laser-hair-removal",
  "/browse/ohio/cincinnati/microneedling",
  "/browse/ohio/columbus",
  "/browse/ohio/columbus/best",
  "/browse/ohio/columbus/botox",
  "/browse/ohio/columbus/chemical-peels",
  "/browse/ohio/columbus/dermal-fillers",
  "/browse/ohio/columbus/dysport",
  "/browse/ohio/columbus/laser-hair-removal",
  "/browse/ohio/columbus/microneedling",
  "/browse/ohio/columbus/sculptra",
  "/browse/ohio/treatments/botox",
  "/browse/ohio/treatments/chemical-peels",
  "/browse/ohio/treatments/coolsculpting",
  "/browse/ohio/treatments/dermal-fillers",
  "/browse/ohio/treatments/hydrafacial",
  "/browse/ohio/treatments/iv-therapy",
  "/browse/ohio/treatments/laser-hair-removal",
  "/browse/ohio/treatments/lip-fillers",
  "/browse/ohio/treatments/microneedling",
  "/browse/ohio/treatments/morpheus8",
  "/browse/ohio/treatments/rf-microneedling",
  "/browse/ohio/treatments/semaglutide-glp-1",
  "/browse/oklahoma",
  "/browse/oklahoma/oklahoma-city",
  "/browse/oklahoma/oklahoma-city/best",
  "/browse/oklahoma/oklahoma-city/botox",
  "/browse/oklahoma/oklahoma-city/dermal-fillers",
  "/browse/oklahoma/oklahoma-city/ipl-photofacial",
  "/browse/oklahoma/oklahoma-city/iv-therapy",
  "/browse/oklahoma/oklahoma-city/laser-hair-removal",
  "/browse/oklahoma/oklahoma-city/medical-weight-loss",
  "/browse/oklahoma/treatments/botox",
  "/browse/oklahoma/treatments/chemical-peels",
  "/browse/oklahoma/treatments/dermal-fillers",
  "/browse/oklahoma/treatments/iv-therapy",
  "/browse/oklahoma/treatments/laser-hair-removal",
  "/browse/oklahoma/treatments/microneedling",
  "/browse/oklahoma/treatments/morpheus8",
  "/browse/oklahoma/treatments/rf-microneedling",
  "/browse/oregon",
  "/browse/oregon/portland",
  "/browse/oregon/portland/best",
  "/browse/oregon/portland/botox",
  "/browse/oregon/portland/chemical-peels",
  "/browse/oregon/portland/coolsculpting",
  "/browse/oregon/portland/dermal-fillers",
  "/browse/oregon/portland/dysport",
  "/browse/oregon/portland/ipl-photofacial",
  "/browse/oregon/portland/iv-therapy",
  "/browse/oregon/portland/kybella",
  "/browse/oregon/portland/laser-hair-removal",
  "/browse/oregon/portland/laser-skin-resurfacing",
  "/browse/oregon/portland/medical-weight-loss",
  "/browse/oregon/portland/microneedling",
  "/browse/oregon/portland/morpheus8",
  "/browse/oregon/portland/prp-injections",
  "/browse/oregon/portland/rf-microneedling",
  "/browse/oregon/portland/sculptra",
  "/browse/oregon/portland/semaglutide-glp-1",
  "/browse/oregon/treatments/botox",
  "/browse/oregon/treatments/chemical-peels",
  "/browse/oregon/treatments/coolsculpting",
  "/browse/oregon/treatments/dermal-fillers",
  "/browse/oregon/treatments/hydrafacial",
  "/browse/oregon/treatments/iv-therapy",
  "/browse/oregon/treatments/laser-hair-removal",
  "/browse/oregon/treatments/lip-fillers",
  "/browse/oregon/treatments/microneedling",
  "/browse/oregon/treatments/morpheus8",
  "/browse/oregon/treatments/rf-microneedling",
  "/browse/oregon/treatments/semaglutide-glp-1",
  "/browse/pennsylvania",
  "/browse/pennsylvania/philadelphia",
  "/browse/pennsylvania/philadelphia/best",
  "/browse/pennsylvania/philadelphia/dermal-fillers",
  "/browse/pennsylvania/philadelphia/laser-hair-removal",
  "/browse/pennsylvania/pittsburgh",
  "/browse/pennsylvania/pittsburgh/best",
  "/browse/pennsylvania/pittsburgh/microneedling",
  "/browse/pennsylvania/treatments/botox",
  "/browse/pennsylvania/treatments/chemical-peels",
  "/browse/pennsylvania/treatments/dermal-fillers",
  "/browse/pennsylvania/treatments/hydrafacial",
  "/browse/pennsylvania/treatments/laser-hair-removal",
  "/browse/pennsylvania/treatments/lip-fillers",
  "/browse/pennsylvania/treatments/microneedling",
  "/browse/pennsylvania/treatments/rf-microneedling",
  "/browse/pennsylvania/treatments/semaglutide-glp-1",
  "/browse/rhode-island",
  "/browse/rhode-island/treatments/botox",
  "/browse/rhode-island/treatments/chemical-peels",
  "/browse/rhode-island/treatments/dermal-fillers",
  "/browse/rhode-island/treatments/hydrafacial",
  "/browse/rhode-island/treatments/iv-therapy",
  "/browse/rhode-island/treatments/laser-hair-removal",
  "/browse/rhode-island/treatments/microneedling",
  "/browse/rhode-island/treatments/morpheus8",
  "/browse/rhode-island/treatments/rf-microneedling",
  "/browse/south-carolina",
  "/browse/south-carolina/treatments/botox",
  "/browse/south-carolina/treatments/chemical-peels",
  "/browse/south-carolina/treatments/dermal-fillers",
  "/browse/south-carolina/treatments/laser-hair-removal",
  "/browse/south-carolina/treatments/microneedling",
  "/browse/south-dakota",
  "/browse/south-dakota/treatments/botox",
  "/browse/south-dakota/treatments/chemical-peels",
  "/browse/south-dakota/treatments/dermal-fillers",
  "/browse/south-dakota/treatments/iv-therapy",
  "/browse/south-dakota/treatments/lip-fillers",
  "/browse/south-dakota/treatments/microneedling",
  "/browse/south-dakota/treatments/semaglutide-glp-1",
  "/browse/tennessee",
  "/browse/tennessee/nashville",
  "/browse/tennessee/nashville/best",
  "/browse/tennessee/nashville/botox",
  "/browse/tennessee/nashville/dermal-fillers",
  "/browse/tennessee/nashville/microneedling",
  "/browse/tennessee/treatments/botox",
  "/browse/tennessee/treatments/dermal-fillers",
  "/browse/tennessee/treatments/microneedling",
  "/browse/texas",
  "/browse/texas/dallas",
  "/browse/texas/dallas/best",
  "/browse/texas/dallas/botox",
  "/browse/texas/dallas/chemical-peels",
  "/browse/texas/dallas/dermal-fillers",
  "/browse/texas/dallas/hydrafacial",
  "/browse/texas/dallas/ipl-photofacial",
  "/browse/texas/dallas/iv-therapy",
  "/browse/texas/dallas/laser-hair-removal",
  "/browse/texas/dallas/laser-skin-resurfacing",
  "/browse/texas/dallas/medical-weight-loss",
  "/browse/texas/dallas/microneedling",
  "/browse/texas/houston",
  "/browse/texas/houston/best",
  "/browse/texas/treatments/botox",
  "/browse/texas/treatments/chemical-peels",
  "/browse/texas/treatments/dermal-fillers",
  "/browse/texas/treatments/hydrafacial",
  "/browse/texas/treatments/iv-therapy",
  "/browse/texas/treatments/laser-hair-removal",
  "/browse/texas/treatments/microneedling",
  "/browse/texas/treatments/semaglutide-glp-1",
  "/browse/utah",
  "/browse/utah/salt-lake-city",
  "/browse/utah/salt-lake-city/best",
  "/browse/utah/salt-lake-city/botox",
  "/browse/utah/salt-lake-city/chemical-peels",
  "/browse/utah/salt-lake-city/dermal-fillers",
  "/browse/utah/salt-lake-city/dysport",
  "/browse/utah/salt-lake-city/laser-hair-removal",
  "/browse/utah/salt-lake-city/medical-weight-loss",
  "/browse/utah/treatments/botox",
  "/browse/utah/treatments/chemical-peels",
  "/browse/utah/treatments/coolsculpting",
  "/browse/utah/treatments/dermal-fillers",
  "/browse/utah/treatments/hydrafacial",
  "/browse/utah/treatments/iv-therapy",
  "/browse/utah/treatments/laser-hair-removal",
  "/browse/utah/treatments/lip-fillers",
  "/browse/utah/treatments/microneedling",
  "/browse/utah/treatments/morpheus8",
  "/browse/utah/treatments/rf-microneedling",
  "/browse/utah/treatments/semaglutide-glp-1",
  "/browse/vermont",
  "/browse/virginia",
  "/browse/virginia/richmond",
  "/browse/virginia/richmond/best",
  "/browse/virginia/richmond/botox",
  "/browse/virginia/richmond/chemical-peels",
  "/browse/virginia/richmond/dermal-fillers",
  "/browse/virginia/richmond/dysport",
  "/browse/virginia/richmond/ipl-photofacial",
  "/browse/virginia/richmond/laser-hair-removal",
  "/browse/virginia/richmond/microneedling",
  "/browse/virginia/richmond/sculptra",
  "/browse/virginia/treatments/botox",
  "/browse/virginia/treatments/chemical-peels",
  "/browse/virginia/treatments/dermal-fillers",
  "/browse/virginia/treatments/hydrafacial",
  "/browse/virginia/treatments/laser-hair-removal",
  "/browse/virginia/treatments/lip-fillers",
  "/browse/virginia/treatments/microneedling",
  "/browse/virginia/treatments/morpheus8",
  "/browse/virginia/treatments/rf-microneedling",
  "/browse/washington",
  "/browse/washington/seattle",
  "/browse/washington/seattle/best",
  "/browse/washington/seattle/botox",
  "/browse/washington/seattle/chemical-peels",
  "/browse/washington/seattle/dermal-fillers",
  "/browse/washington/seattle/dysport",
  "/browse/washington/seattle/emsculpt",
  "/browse/washington/seattle/ipl-photofacial",
  "/browse/washington/seattle/iv-therapy",
  "/browse/washington/seattle/kybella",
  "/browse/washington/seattle/laser-hair-removal",
  "/browse/washington/seattle/laser-skin-resurfacing",
  "/browse/washington/seattle/medical-weight-loss",
  "/browse/washington/seattle/microneedling",
  "/browse/washington/seattle/rf-microneedling",
  "/browse/washington/seattle/sculptra",
  "/browse/washington/seattle/semaglutide-glp-1",
  "/browse/washington/treatments/botox",
  "/browse/washington/treatments/chemical-peels",
  "/browse/washington/treatments/coolsculpting",
  "/browse/washington/treatments/dermal-fillers",
  "/browse/washington/treatments/hydrafacial",
  "/browse/washington/treatments/iv-therapy",
  "/browse/washington/treatments/laser-hair-removal",
  "/browse/washington/treatments/lip-fillers",
  "/browse/washington/treatments/microneedling",
  "/browse/washington/treatments/morpheus8",
  "/browse/washington/treatments/rf-microneedling",
  "/browse/washington/treatments/semaglutide-glp-1",
  "/browse/west-virginia",
  "/browse/west-virginia/treatments/microneedling",
  "/browse/wisconsin",
  "/browse/wisconsin/madison",
  "/browse/wisconsin/madison/best",
  "/browse/wisconsin/madison/botox",
  "/browse/wisconsin/madison/chemical-peels",
  "/browse/wisconsin/madison/dermal-fillers",
  "/browse/wisconsin/madison/laser-hair-removal",
  "/browse/wisconsin/madison/laser-skin-resurfacing",
  "/browse/wisconsin/madison/microneedling",
  "/browse/wisconsin/madison/sculptra",
  "/browse/wisconsin/madison/semaglutide-glp-1",
  "/browse/wisconsin/treatments/botox",
  "/browse/wisconsin/treatments/chemical-peels",
  "/browse/wisconsin/treatments/coolsculpting",
  "/browse/wisconsin/treatments/dermal-fillers",
  "/browse/wisconsin/treatments/laser-hair-removal",
  "/browse/wisconsin/treatments/microneedling",
  "/browse/wisconsin/treatments/rf-microneedling",
  "/browse/wisconsin/treatments/semaglutide-glp-1",
  "/browse/wyoming",
  "/browse/wyoming/treatments/botox",
  "/browse/wyoming/treatments/chemical-peels",
  "/browse/wyoming/treatments/dermal-fillers",
  "/browse/wyoming/treatments/iv-therapy",
  "/browse/wyoming/treatments/laser-hair-removal",
  "/browse/wyoming/treatments/microneedling"
];

export const INDEXABLE_BROWSE_PATH_SET: ReadonlySet<string> = new Set(
  INDEXABLE_BROWSE_PATHS,
);
